// extracted by mini-css-extract-plugin
export default {"button":"ZDjoqf","secondary":"s6sLVn","dark":"MVftb7","light":"Od7m8I"};